import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { useEffect, useState } from "react";
import es from "./locales/es.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";

export const LANGS = [
  { code: "es", label: "Español", flag: "🇲🇽", locale: "es-MX" },
  { code: "en", label: "English", flag: "🇺🇸", locale: "en-US" },
  { code: "fr", label: "Français", flag: "🇫🇷", locale: "fr-FR" },
  { code: "de", label: "Deutsch", flag: "🇩🇪", locale: "de-DE" },
];
const KEY = "circulo_lang";
const valid = (c) => (LANGS.some((l) => l.code === c) ? c : null);

i18next.use(initReactI18next).init({
  resources: { es: { translation: es }, en: { translation: en }, fr: { translation: fr }, de: { translation: de } },
  lng: valid(localStorage.getItem(KEY)) || "es",
  fallbackLng: "es",
  interpolation: { escapeValue: false },
  returnNull: false,
});

const apply = (lng) => {
  document.documentElement.lang = lng;
  document.title = i18next.t("app.title");
};
apply(i18next.language);
i18next.on("languageChanged", apply);

export const t = (key, opts) => i18next.t(key, opts);
export const getLang = () => i18next.language;
export const getLocale = () => LANGS.find((l) => l.code === i18next.language)?.locale || "es-MX";
export const setLang = (code) => {
  const c = valid(code);
  if (!c || c === i18next.language) return;
  localStorage.setItem(KEY, c);
  i18next.changeLanguage(c);
};

export function useLang() {
  const [lng, setLng] = useState(i18next.language);
  useEffect(() => {
    const h = (l) => setLng(l);
    i18next.on("languageChanged", h);
    return () => i18next.off("languageChanged", h);
  }, []);
  return lng;
}

export default i18next;
